<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/algorithm/combination/page" getKey="rows" :columns="columns" v-loading="loading">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('suanfazuhemingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-button @click="yt.get(1)" type="primary" plain="plain" size="mini">
            {{ $t('sousuo') }}
          </el-button>
          <el-button @click="yt.clear()" size="mini">{{ $t('chongzhi') }} </el-button>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form>
      </template>

      <template #shifoumorensuanfa="scope">
        {{ scope.row.defaultVal === false ? $t('fou') : $t('shi') }}
      </template>

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_scheduling_algorithm_combination_update')" type="text" @click="yt.showEditDialog('bianji', scope.row, '70%')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_scheduling_algorithm_combination_set_default_algorithm') && scope.row.defaultVal === false" type="text" @click="setDefaultAlgorithm(scope.row.id)">{{ $t('shezhimorensuanfa') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <div style="display: flex; flex-direction: column; align-items: center;">
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
              <el-form-item :label="$t('suanfazuhemingcheng') + ':'" required>
                <el-input v-model="yt.editObj.name" />
              </el-form-item>
              <br />
              <el-form-item :label="$t('beizhu') + ':'">
                <el-input v-model="yt.editObj.remark" />
              </el-form-item>
              <br />
              <el-form-item :label="$t('shifoumorensuanfa') + ':'">
                <el-select v-model="yt.editObj.defaultVal" disabled>
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <combination_item :combination="yt.editObj"></combination_item>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/algorithm/combination/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'bianjisuanfayinzi'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('algorithmFactor') + ':'" required>
            {{ yt.editObj.algorithmFactor }}
          </el-form-item>
          <el-form-item :label="$t('miaoshu') + ':'" required>
            {{ yt.editObj.describe }}
          </el-form-item>
          <el-form-item :label="$t('weights-from') + ':'" required>
            <el-input-number v-model="yt.editObj.weights" :controls="false" :max="10" :min="1" />
            <br />
            <span style="font-size: 10px;color: red">{{ $t('qingshuru1-10,10daibiaoquanzhongzuigao') }}</span>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong') + ':'" required>
            <el-select v-model="yt.editObj.enableFlag">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/scheduling/algorithm/setting/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import combination_item from '@@/pages/web/scheduling/algorithm_combination/combination_item';
export default {
  name: 'web_scheduling_algorithm_combination',
  components: {
    combination_item
  },
  data() {
    return {
      loading: false,
      columns: [
        {
          label: 'suanfazuhemingcheng',
          prop: 'name'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'shifoumorensuanfa',
          type: 'slot'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ],
      formRules: {
        weights: [{ required: true }]
      }
    };
  },
  methods: {
    setDefaultAlgorithm(id) {
      this.http
        .post('/web/algorithm/combination/setDefaultAlgorithm', id)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('success')
          });
          this.yt.get(1);
        })
        .catch(() => {});
    }
  },
  dataInit() {
    this.$confirm(this.$t('cicaozuojiangchushihuasuanfayinzi,shifoujixu?'), this.$t('tishi'), {
      confirmButtonText: this.$t('queding'),
      cancelButtonText: this.$t('quxiao'),
      type: 'warning',
      beforeClose: (action, instance, done) => {
        if (action === 'confirm') {
          // 在确定按钮点击时添加loading效果
          instance.confirmButtonLoading = true;
          // 执行操作...
          // 操作完成后，手动关闭对话框
          done();
          setTimeout(() => {
            instance.confirmButtonLoading = false;
            done();
          }, 2000);
        } else {
          // 取消按钮点击或者点击遮罩层时，直接关闭对话框
          done();
        }
      }
    })
      .then(() => {
        this.loading = true;
        this.http
          .post('/web/scheduling/algorithm/setting/init')
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('success')
            });
            this.yt.get(1);
          })
          .finally(() => {
            // this.loading = false
          });
      })
      .catch(() => {});
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  }
};
</script>

<style scoped lang="scss"></style>
